import { connect } from 'react-redux';
import RoutesComponent from '../components/routes';

const mapStateToProps = (state, props) => {
  return {
    ...props,
    routes: state.route.routes,
    subRoutes: state.route.subRoutes,
  };
};

export default connect(mapStateToProps)(RoutesComponent);
